import React, { useState } from 'react';
import TEAMS from '../data/teams';

const leagues = [...new Set(TEAMS.map(t => t.league))];

export default function TeamSelect({ onBack, onStart, singleSelect }) {
  const [homeTeam, setHomeTeam] = useState(null);
  const [awayTeam, setAwayTeam] = useState(null);
  const [step, setStep] = useState('home'); // home | away
  const [selectedLeague, setSelectedLeague] = useState(leagues[0]);

  const filteredTeams = TEAMS.filter(t => t.league === selectedLeague);

  const handleTeamClick = (team) => {
    if (singleSelect) {
      setHomeTeam(team);
      return;
    }
    if (step === 'home') {
      setHomeTeam(team);
      setStep('away');
    } else {
      if (team.id === homeTeam.id) return;
      setAwayTeam(team);
    }
  };

  const handleStart = () => {
    if (singleSelect && homeTeam) {
      onStart(homeTeam, null);
    } else if (homeTeam && awayTeam) {
      onStart(homeTeam, awayTeam);
    }
  };

  const resetSelection = () => {
    setHomeTeam(null);
    setAwayTeam(null);
    setStep('home');
  };

  return (
    <div className="team-select">
      <div className="ts-header">
        <button className="ts-back" onClick={onBack}>← Geri</button>
        <h1>TAKIM SEÇ</h1>
        <div className="ts-step-info">
          {singleSelect ? 'Turnuva Takımını Seç' : step === 'home' ? 'Kendi Takımını Seç' : 'Rakip Takımı Seç'}
        </div>
      </div>

      {/* Seçilen takımlar */}
      <div className="ts-matchup">
        <div className={`ts-selected-team ${homeTeam ? 'filled' : ''}`}>
          {homeTeam ? (
            <>
              <div className="ts-team-badge" style={{
                background: homeTeam.colors.primary,
                color: homeTeam.colors.secondary,
                border: `3px solid ${homeTeam.colors.secondary}`
              }}>
                {homeTeam.shortName}
              </div>
              <span className="ts-team-name">{homeTeam.name}</span>
              <span className="ts-team-rating">⭐ {homeTeam.rating}</span>
            </>
          ) : (
            <span className="ts-placeholder">Ev Sahibi</span>
          )}
        </div>

        <div className="ts-vs">VS</div>

        <div className={`ts-selected-team ${awayTeam ? 'filled' : ''}`}>
          {awayTeam ? (
            <>
              <div className="ts-team-badge" style={{
                background: awayTeam.colors.primary,
                color: awayTeam.colors.secondary,
                border: `3px solid ${awayTeam.colors.secondary}`
              }}>
                {awayTeam.shortName}
              </div>
              <span className="ts-team-name">{awayTeam.name}</span>
              <span className="ts-team-rating">⭐ {awayTeam.rating}</span>
            </>
          ) : (
            <span className="ts-placeholder">Deplasman</span>
          )}
        </div>
      </div>

      {/* Lig seçimi */}
      <div className="ts-leagues">
        {leagues.map(league => (
          <button
            key={league}
            className={`ts-league-btn ${selectedLeague === league ? 'active' : ''}`}
            onClick={() => setSelectedLeague(league)}
          >
            {league}
          </button>
        ))}
      </div>

      {/* Takım listesi */}
      <div className="ts-teams-grid">
        {filteredTeams.map(team => (
          <button
            key={team.id}
            className={`ts-team-card ${homeTeam?.id === team.id ? 'selected-home' : ''} ${awayTeam?.id === team.id ? 'selected-away' : ''} ${step === 'away' && homeTeam?.id === team.id ? 'disabled' : ''}`}
            onClick={() => handleTeamClick(team)}
          >
            <div className="ts-card-badge" style={{
              background: team.colors.primary,
              color: team.colors.secondary,
              border: `2px solid ${team.colors.secondary}`
            }}>
              {team.shortName}
            </div>
            <span className="ts-card-name">{team.name}</span>
            <span className="ts-card-rating">{team.rating}</span>
          </button>
        ))}
      </div>

      {/* Butonlar */}
      <div className="ts-actions">
        <button className="ts-reset" onClick={resetSelection}>Sıfırla</button>
        {((singleSelect && homeTeam) || (!singleSelect && homeTeam && awayTeam)) && (
          <button className="ts-start" onClick={handleStart}>
            {singleSelect ? '🏆 TURNUVAYA GİT' : '⚽ MAÇA BAŞLA'}
          </button>
        )}
      </div>
    </div>
  );
}
